import { customModelLabel } from '@/features/mockModel/customProviders'
import { DO_MEK_LABEL } from '@/features/mockModel/mockModelLabels'
import Row from './AiAskBarHomeRightAgentSelectRow'
import styles from './index.module.scss'

const onEnter = (action) => (event) => event.key === 'Enter' && action()
const NEW_BADGE = <span className={styles.agentControlNewBadge}>New</span>

/**
 * DO Mek and Custom, between Auto and the provider list. Hovering either one
 * closes any open provider submenu, as moving onto a plain row should.
 */
export default function AiAskBarHomeRightAgentSelectMockEntries({ mock, onRowEnter }) {
  const customMeta = mock.custom ? customModelLabel(mock.custom.provider, mock.custom.model) : 'Your API key'
  return (
    <>
      <Row
        label={DO_MEK_LABEL}
        meta={NEW_BADGE}
        isSelected={mock.choice === 'do-mek'}
        onClick={mock.chooseDoMek}
        onMouseEnter={onRowEnter}
        onKeyDown={onEnter(mock.chooseDoMek)}
      />
      <Row
        label="Custom"
        meta={customMeta}
        isSelected={mock.choice === 'custom'}
        showChevron
        onClick={mock.openCustom}
        onMouseEnter={onRowEnter}
        onKeyDown={onEnter(mock.openCustom)}
      />
    </>
  )
}
